import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { reportDataDebtsRe } from '@constants/reports/report-debts-re';
import { SelectOption } from '@interfaces/input-select-option.interface';
import { Report } from '@interfaces/report/report.interface';
import { Utils } from '@json/src/app/Utils';
import { CallsService } from '@services/api/calls.service';
import { InstitutionService } from '@services/institution.service';
import { ReportsService } from '@services/reports/reports.service';
import { RoleManagerService } from '@services/role-manager.service';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import moment from 'moment';
import { LoggerService } from '@services/logger.service';
import { UserAction } from '@enums/user-action';

@Component({
    selector: 'app-report-debts-re',
    templateUrl: './report-debts-re.component.html',
    styleUrls: ['../report-change-medications/report-change-medications.component.scss'],
})
export class ReportDebtsReComponent {
    public reportData = reportDataDebtsRe;
    public form: FormGroup;
    public currentRoute: string;
    public report: Report;
    public safeURL: SafeUrl;

    public selectOptionsInsitutions: SelectOption[];
    public typeGlobal: boolean = false;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private calls: CallsService,
        private reportService: ReportsService,
        private institutionService: InstitutionService,
        private roleManager: RoleManagerService,
        private titleService: Title,
        private gaService: GoogleAnalyticsService,
        private logger: LoggerService
    ) {
        this.form = this.formBuilder.group({
            checkboxDoctorSS: [true],
            selectedInstitution: ['', Validators.required],
        });
        this.currentRoute = this.router.url;
    }

    ngOnInit(): void {
        this.titleService.setTitle(`Reporte: Deudas + RE`);
        this.gaService.pageView(`${window.location.href}`, `Reporte: Deudas + RE`);
        this.logger.logPage('Reporte: Deudas + RE');

        this.typeGlobal = this.roleManager.isPharma() || this.roleManager.isHospitalPharma();

        this.getDataForTheSelects();
    }

    getDataForTheSelects(): void {
        this.institutionService.getInstitutions().then(() => {
            this.selectOptionsInsitutions =
              Object.assign([], this.institutionService.institutionList.getValue());

            this.selectOptionsInsitutions = this.selectOptionsInsitutions.sort((a, b) => a.label.localeCompare(b.label));

            if (this.selectOptionsInsitutions) {
              const hasEmptyValue = this.selectOptionsInsitutions.some(
                (item) => item.value === ''
              );
              if (hasEmptyValue) {
                this.selectOptionsInsitutions = this.selectOptionsInsitutions.filter(
                  (item) => item.value !== ''
                );
              }
            }

            if ( !this.typeGlobal ) {
                this.form.controls['selectedInstitution'].setValue({id: this.institutionService.getCurrentInstitution()})
            }
          });
    }

    handlePreviewClick() {
        if (this.form.valid) {
            this.setInfoRP(true);
            this.reportService.handlePreviewClick(this.router, this.reportData);

            this.logger.logAction(UserAction.Click, {
                message: 'Vista previa',
                ...this.reportData.data
            });
        } else {
            this.calls.openSnack('Debes seleccionar un centro');
        }
    }

    handlePrintClick() {
        if (this.form.valid) {
            this.setInfoRP();
            this.reportService.handlePrintClick(this.reportData);

            this.logger.logAction(UserAction.Click, {
                message: 'Impresión',
                ...this.reportData.dataRenderReport
            });
        } else {
            this.calls.openSnack('Debes seleccionar un centro');
        }
    }

    handlePdfClick() {
        if (this.form.valid) {
            this.setInfoRP();
            this.reportService.handlePdfClick(this.reportData);

            this.logger.logAction(UserAction.Click, {
                message: 'Exportar PDF',
                ...this.reportData.dataDownloadPDF
            });
        } else {
            this.calls.openSnack('Debes seleccionar un centro');
        }
    }

    handleExcelClick() {
        if (this.form.valid) {
            this.setInfoRP();
            this.reportService.handleExcelClick(this.reportData);

            this.logger.logAction(UserAction.Click, {
                message: 'Exportar Excel',
                ...this.reportData.dataDownloadExcel
            });
        } else {
            this.calls.openSnack('Debes seleccionar un centro');
        }
    }

    setInfoRP(isPreview: boolean = false): void {
        const checkboxDoctorSS = this.form.get('checkboxDoctorSS')?.value;

        let currentInstitution;
        const dataForm = this.form.getRawValue();
        //@ts-ignore
        currentInstitution = dataForm.selectedInstitution.id;

        const rp = JSON.stringify({
            LocaleId: '3082',
            PatientId: null,
            InstitutionId: String(currentInstitution),
            GroupMedicoSS: checkboxDoctorSS ? 'true' : null,
        });

        this.reportData.data.rp = rp;
        if (isPreview) this.reportData.data.dn = Utils.buildUniqueFileName + "_{0}.html";
        this.reportData.dataDownloadPDF.rp = rp;
        this.reportData.dataDownloadExcel.rp = rp;
        this.reportData.dataRenderReport.rp = rp;

        const now = moment();
        this.reportData.dataDownloadPDF.dn = this.reportData.dataRenderReport.dn =
            `Reporte_de_deudas_re_${this.institutionService.getCurrentInstitutionShortName()}_${now.format('YYYYMMDD')}_${now.format('HHMM')}.pdf`;
        this.reportData.dataDownloadExcel.dn = `Reporte_de_deudas_re_${this.institutionService.getCurrentInstitutionShortName()}_${now.format('YYYYMMDD')}_${now.format('HHMM')}.xls`;
    }
}
